<template>
  <router-view />
</template>

<script>

export default {
  name: "App",

  data: () => ({}),
  methods: {
    redirect(path) {
      return this.$router.push(path);
    }
  }
};
</script>
